import { Container, Row } from 'reactstrap'
import BasicPopover from './BasicPopover/BasicPopover'
import PopoverDirection from './PopoverDirection/PopoverDirection'
import PopoverOffset from './PopoverOffset/PopoverOffset'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs'
import { Popover, BreadcrumbUiKits } from '../../../utils/Constant'

const PopoverContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Popover} parent={BreadcrumbUiKits} />
      <Container fluid>
        <Row className='popover-main'>
          <BasicPopover />
          <PopoverDirection />
          <PopoverOffset />
        </Row>
      </Container>
    </>
  )
}

export default PopoverContainer